module.exports = __webpack_public_path__ + "img/bg.e94be405.jpeg";